import React, {Component} from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import css from './Customers.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import axios from 'axios';
import getDateQry from "../../helpers/dateHelpers";
import replaceStageName from "../../utils/replaceStageName";
import replaceInternalStage from "../../utils/replaceInternalStage";
import {timePeriods, DEFAULT_SELECTED_TIME_PERIOD } from "../../helpers/timePeriods";
import {connect} from "react-redux";
import moment from 'moment';
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import DropDown from "../../components/DropDown/DropDown";
import _ from 'lodash';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';


/**
 * @class
 *
 * Customers page.
 */
const Customers = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    postRequestAccountManagementRecords = {
        "limit": 500,
        "skip": 0,
        "fields": [
            "Id",
            "Assigned_Account_Manager__r.Name",
            "Reviewed_Date__c",
            "Next_Step__c",
            "Action_Required__c",
            "Rep_Action_Requested__c",
            "Rep_Action_Resolved__c",
            "Opportunity__r.Name",
            "Opportunity__c"
        ],
        "where": {
            "$or": [
                {
                    "Opportunity__r.Sales_Representative__c":      this.props.user.apiId
                },
                {
                    "Opportunity__r.Sales_Representative_2__c":    this.props.user.apiId
                },
                {
                    "Opportunity__r.Sales_Representative_3__c":    this.props.user.apiId
                }
            ],
            "Opportunity__c": {$ne: null},
            "Opportunity__r.Fake__c": false,
            "Opportunity__r.StageName": {$nin: ['Cancelled', 'Completed']}
        }
    }

    // ---------- state: ----------
    state = {
        postRequestData: {
            "limit": 500,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "CloseDate",
                "Internal_Stage__c",
                "StageName",
                "Type",
                "Post_System_Size__c",
                "Completed_Deal_Docs__c",
                "Sales_Representative__c",
                "Sales_Representative__r.Name",
                "Sales_Representative__r.Phone",
                "Sales_Representative_2__c",
                "Sales_Representative_2__r.Name",
                "Sales_Representative_2__r.Phone",
                "Sales_Representative_3__c",
                "Sales_Representative_3__r.Name",
                "Sales_Representative_3__r.Phone",
                "System_Size__c",
                "Deal_Documents__c",
                "Deal_Documents__r.Missing_Deal_Docs_for_Dashboard__c",
                "Post_Appointment_Time__c",
                "Post_Appointment_Completed_DT__c",
                "Pending_Sale_Date__c",
                "Sold_Deal_Date__c",
                "Sub_Status_new__c",
                "Status__c",
                "Preferred_Escalator__c"
            ],
            "where": {
                "$or": [
                    {
                        "Sales_Representative__c":      this.props.user.apiId
                    },
                    {
                        "Sales_Representative_2__c":    this.props.user.apiId
                    },
                    {
                        "Sales_Representative_3__c":    this.props.user.apiId
                    }
                ],
                "Fake__c": false
            },
            "date": {
                ...getDateQry(DEFAULT_SELECTED_TIME_PERIOD, 'CloseDate')
            }
        },
        optionsTimePeriod: timePeriods,
        filterKeyword: '',
        tableData: [],
        filterStagesOptions: [],
        filterTypesOptions: [],
        filterStatusOptions: [],
        filterActionRequiredOptions: [
            {label: 'Default', value: 'Default'}, 
            {label: 'Rep Action Needed', value: 'Rep Action Needed'},
            {label: 'No Action Needed', value: 'No Action Needed'}],
        selectedStages: [],
        selectedTypes: [],
        selectedStatuses: [],
        selectedActionRequired: '',
        showName: false,
        showPending_Sale_Date__c: true,
        showStageName: false,
        showActionRequiredOnly: false,
        expandedTimelineRow: '',
        accountManagementRecords: []
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        window.scrollTo(0, 0);
        // fetch data from Salesforce:
        this.fetchRecords();
        this.fetchAccountManagementRecords();

        axios.get(
            '/sf/metaData',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const filterStagesOptions = res.data.stages.visible.map(item => {
                    return {
                        ...item,
                        label: replaceInternalStage(item.label), // replacing label of the stage if needed
                        checked: true
                    };
                });

                const filterTypesOptions = res.data.types.visible.map(item => {
                    return {
                        ...item,
                        checked: true
                    }
                });

                const filterStatusOptions = res.data.fin_stages.visible.map(item => {
                    return {
                        ...item,
                        checked: true
                    }
                });

                this.setState({
                    filterStagesOptions,
                    filterTypesOptions,
                    filterStatusOptions,

                    selectedStages: filterStagesOptions.map(item => item.value),
                    selectedTypes: filterTypesOptions.map(item => item.value),
                    selectedStatuses: filterStatusOptions.map(item => item.value),
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('Error:\n', err);
                }
            });
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    // ---------- methods: ----------
    /**
     * @method
     * @methodOf Customers
     *
     * Fetches records/table data.
     */
    fetchRecords = () => {
        axios.post(
            'sf/opportunity/find',
            this.state.postRequestData,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const sortedData = _.orderBy(res.data.records, ['CloseDate'], ['desc']);
                this.setState({
                    tableData: sortedData
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(POST) Error trying to fetch opportunity records:\n', err);
                }
            });
    };

    fetchAccountManagementRecords = () => {
        axios.post(
            'sf/AccountManagement/findNo',
            this.postRequestAccountManagementRecords,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const accountManagementRecords = res.data.records ?? [];

                accountManagementRecords.forEach(record => {
                    record.actionRequired = [];
                    const repActions = ['Pending Rep Approval', 'Documents Required', 'Out of Pocket Required', 'Change Order Required', 'New Agreement Required', 'EPC Change Required', 'Customer Correspondence Required'];

                    if(record.Action_Required__c){
                        record.Action_Required__c.split(';').forEach(action => {
                            record.actionRequired.push({name: action, isRepAction: repActions.includes(action)});
                        });
                    }
                });

                this.setState({
                    accountManagementRecords: accountManagementRecords
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(POST) Error trying to fetch account management records:\n', err);
                }
            });
    }

    // TODO: this method is exact copy as in KPIs and Leads -- should reuse function from utils:
    /**
     * @method
     * @methodOf Customers
     *
     * Handler for filter input -- filters the Leads table by the "name" column in the table.
     *
     * N.b. input field/filtering is case-insensitive. Updates state: the user input (filter keyword) the displayed table data (filtered by user input).
     * @param event {event}: HTML event. TODO: to be more consistent we should just pass the event value (`event.target.value`) instead.
     */
    handleFilterOnChange = (event) => {
        const filterKeyword = event.target.value.toLowerCase();

        this.setState({
            filterKeyword
        });
    };

    /**
     * @method
     * @methodOf Customers
     *
     * Handler for when user selects a time period from dropdown -- fetches data based on the selected time period.
     *
     * @param val {string}: The time period string.
     */
    timePeriodDropdownOnChange = (val) => {
        // select time period object from list based on selected drop down value:
        const selectedTimePeriod = timePeriods.find(item => item.value === val);

        // update object for POST request with selected time period:
        const postRequestData = {...this.state.postRequestData};
        postRequestData.date = {...getDateQry(selectedTimePeriod, 'CloseDate')};

        // fetch data after updating post data:
        this.setState({
                postRequestData
            },
            this.fetchRecords
        );
    };

    /**
     * @method
     * @methodOf Customers
     *
     * Handler for when user selects the "stage" to filter.
     *
     * @param optionList {array}: Array of objects, where each object represents a stage (fetched from server).
     */
    filterByStagesOnChange = (optionList) => {
        const selectedStages = optionList
            .filter(item => item.checked)
            .map(item => item.value);

        this.setState({
            filterStagesOptions: optionList,
            selectedStages,
        });
    };

    /**
     * @method
     * @methodOf Customers
     *
     * Handler for when user selects the "type" to filter.
     *
     * @param optionList {array}: Array of objects, where each object represents a type (fetched from server).
     */
    filterByTypesOnChange = (optionList) => {
        const selectedTypes = optionList
            .filter(item => item.checked)
            .map(item => item.value);

        this.setState({
            filterTypesOptions: optionList,
            selectedTypes,
        });
    };

    /**
     * @method
     * @methodOf Customers
     *
     * Handler for when user selects the "status" to filter.
     *
     * @param optionList {array}: Array of objects, where each object represents a status (fetched from server).
     */
    filterByStatusOnChange = (optionList) => {
        const selectedStatuses = optionList
            .filter(item => item.checked)
            .map(item => item.value);

        this.setState({
            filterStatusOptions: optionList,
            selectedStatuses,
        });
    };

    /**
     * @method
     * @methodOf Customers
     *
     * Handler for when user selects the "stage" to filter.
     *
     * @param optionList {array}: Array of objects, where each object represents an action required (fetched from server).
     */
    filterByActionRequiredOnChange = (value) => {
        this.setState({
            selectedActionRequired: value
        });
    };

    /**
     * @method
     * @methodOf Customers
     *
     * The displayed table after all filters and sorting have been applied.
     *
     * @return {array}: The `tableData` array but filtered by keyword, stage, type, and status.
     */
    displayedCustomersTable = () => {
        // filter table by filter keyword:
        return this.state.tableData
            .filter(item => {
                const itemName = item.Name.toLowerCase();
                return itemName.includes(this.state.filterKeyword);
            })
            // filter by selected stage (drop down):
            .filter(item => this.state.selectedStages.includes(item.Internal_Stage__c))
            // filter by selected type (drop down):
            .filter(item => this.state.selectedTypes.includes(item.Type))
            // // filter by selected status (drop down):
            .filter(item => this.state.selectedStatuses.includes(item.StageName));
    };

    displayedTimelineTable = () => {
        // filter table by filter keyword:
        return this.state.accountManagementRecords
            .filter(item => {
                // Logic to filter by name when user searches for a specific customer by name.
                const itemName = item.Opportunity__r.Name.toLowerCase();
                if(this.state.filterKeyword && !itemName.includes(this.state.filterKeyword)){
                    return false;
                }

                // Logic to show only customers with rep action required when user selects "Rep Action Required" from the dropdown.
                if(this.state.selectedActionRequired === 'Rep Action Needed' && !item.Rep_Action_Requested__c){
                    return false;
                }

                // Logic to show only customers with no action needed when user selects "No Action Needed" from the dropdown.
                if(this.state.selectedActionRequired === 'No Action Needed' && item.Action_Required__c){
                    return false;
                }

                return true;
            })
    };

    tableSort (value) {
        let sortedData = '';
        let show = 'show' + value;
        let showName = false;
        let showPending_Sale_Date__c = false;
        let showStageName = false;

        switch (show) {
            case 'showName' :
                showName = true;
            break;

            case 'showPending_Sale_Date__c' : 
                showPending_Sale_Date__c = true;
            break;

            case 'showStageName' :
                showStageName = true;
            break;

            default:
            break;
        }

        if(value === 'Pending_Sale_Date__c') {
            sortedData = _.orderBy(this.state.tableData, [value], ['desc']);
        } else {
            sortedData = _.orderBy(this.state.tableData, [value], ['asc']);
        }
        this.setState({ 
            tableData: sortedData,
            showName: showName,
            showPending_Sale_Date__c: showPending_Sale_Date__c,
            showStageName: showStageName
        })
    };

    render() {
        return (
            <div className={css.Customers}>
                <SectionHeading heading="Customers" />

                <div className="mt-3 mb-2">
                    <div className="form-group">
                        <div className="btn-group btn-group-toggle">
                            <label className={"btn " + (!this.state.showActionRequiredOnly ? "btn-primary" : "btn-outline-secondary")}
                                    onClick={() => this.setState({ showActionRequiredOnly: false })}>
                                All Customers
                            </label>
                            <label className={"btn " + (this.state.showActionRequiredOnly ? "btn-primary" : "btn-outline-secondary")}
                                    onClick={() => this.setState({ showActionRequiredOnly: true })}>
                                Timeline View
                            </label>
                        </div>
                    </div>
                </div>

                {/* ---------- page controls row 1: ---------- */}
                <div className={!this.state.showActionRequiredOnly ? "row" : "d-none"}>
                    <div className="col-sm-12">
                        <h4>When</h4>
                    </div>
                </div>
                <div className={!this.state.showActionRequiredOnly ? "row" : "d-none"}>
                    <div className="col-sm-12 col-md-4">
                        <select id="timePeriod" onChange={(event) => this.timePeriodDropdownOnChange(event.target.value)} defaultValue={DEFAULT_SELECTED_TIME_PERIOD.value}>
                            {
                                // ----- select options - time period: -----
                                this.state.optionsTimePeriod.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)
                            }
                        </select>
                    </div>
                </div>

                {/* ---------- page controls row 2: ---------- */}
                <div className={!this.state.showActionRequiredOnly ? "row pt-4" : "d-none"}>
                    <div className="col-12 col-lg-3">
                        {/* ----- filter table data: ----- */}
                        <div className="input-with-icons-container">
                            <FontAwesomeIcon icon={faFilter} />
                            <input className="input"
                                   type="text"
                                   placeholder="Filter Results"
                                   value={this.state.filterKeyword}
                                   onChange={(event) => this.handleFilterOnChange(event)}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-sm-8 col-lg-6 mt-4 mt-lg-0 mb-2 mb-md-0">
                        <div className="d-flex">
                            <CheckboxDropDown
                                button-outline
                                options={this.state.filterStagesOptions}
                                onDropdownSelect={(options) => this.filterByStagesOnChange(options)}
                                text="Stages"
                            />
                            <CheckboxDropDown
                                button-outline
                                options={this.state.filterTypesOptions}
                                onDropdownSelect={(options) => this.filterByTypesOnChange(options)}
                                text="Types"
                            />
                            <CheckboxDropDown
                                button-outline
                                options={this.state.filterStatusOptions}
                                onDropdownSelect={(options) => this.filterByStatusOnChange(options)}
                                text="Status"
                            />
                        </div>
                    </div>
                    {/* ----- show # of results: ----- */}
                    <div className="col-12 col-sm-4 col-lg-3 mt-4 mt-md-0 d-flex align-items-center justify-content-end">
                        Showing {this.displayedCustomersTable().length} of {this.state.tableData.length}
                    </div>
                </div>
                <div className={this.state.showActionRequiredOnly ? "row pt-4" : "d-none"}>
                    <div className="col-12 col-lg-3">
                        {/* ----- filter table data: ----- */}
                        <div className="input-with-icons-container">
                            <FontAwesomeIcon icon={faFilter} />
                            <input className="input"
                                   type="text"
                                   placeholder="Filter Results"
                                   value={this.state.filterKeyword}
                                   onChange={(event) => this.handleFilterOnChange(event)}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-sm-8 col-lg-6 mt-4 mt-lg-0 mb-2 mb-md-0">
                        <div className="d-flex">
                            <DropDown
                                button-outline
                                options={this.state.filterActionRequiredOptions}
                                onDropdownSelect={(value) => this.filterByActionRequiredOnChange(value)}
                                default={{label: 'Select Filter', value: 'Select Filter'}} // defaulting to a nonexisting value to show a placeholder.
                            />
                        </div>
                    </div>
                    {/* ----- show # of results: ----- */}
                    <div className="col-12 col-sm-4 col-lg-3 mt-4 mt-md-0 d-flex align-items-center justify-content-end">
                        Showing {this.displayedTimelineTable().length} of {this.state.accountManagementRecords.length}
                    </div>
                </div>

                {!this.state.showActionRequiredOnly ? (
                    // ********** All Customers View **********
                    window.innerWidth <= 760 ? 

                    <div>
                        {/* ---------- Customers Table: ---------- */}
                        <table class="table table-sm table-borderless">
                            <thead>
                            <tr>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Name')}>Name {this.state.showName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>Stage</th>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Pending_Sale_Date__c')}>Signed {this.state.showPending_Sale_Date__c ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('StageName')}>Status {this.state.showStageName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                // ----- table rows: -----
                                this.displayedCustomersTable()
                                    .map((customer) => {
                                        return (
                                            <tr key={ customer.Id }>
                                                <td>
                                                    <Link to={`/customers/${customer.Id}`}>{ customer.Name }</Link>
                                                </td>
                                                <td>{ replaceInternalStage(customer.Internal_Stage__c) }</td>
                                                <td>{ moment(customer.Pending_Sale_Date__c).format('MMM D') }</td>
                                                <td>{ replaceStageName(customer) }</td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>

                    :

                    <div>
                        {/* ---------- Customers Table: ---------- */}
                        <table>
                            <thead>
                            <tr>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Name')}>Name {this.state.showName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>Stage</th>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Pending_Sale_Date__c')}>Signed {this.state.showPending_Sale_Date__c ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>Type</th>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('StageName')}>Status {this.state.showStageName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>KW</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                // ----- table rows: -----
                                this.displayedCustomersTable()
                                    .map((customer) => {
                                        return (
                                            <tr key={ customer.Id }>
                                                <td>
                                                    <Link to={`/customers/${customer.Id}`}>{ customer.Name }</Link>
                                                </td>
                                                <td>{ replaceInternalStage(customer.Internal_Stage__c) }</td>
                                                <td>{ moment(customer.Pending_Sale_Date__c).format('MMM D') }</td>
                                                <td>{ customer.Type }</td>
                                                <td>{ replaceStageName(customer) }</td>
                                                <td><h3>{ (customer.Post_System_Size__c || customer.System_Size__c || 0).toFixed(1) }</h3></td>
                                            </tr>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                ) : (
                    // ********** Timeline View **********

                    window.innerWidth <= 760 ? 

                    <div>
                        {/* ---------- Customers Table: ---------- */}
                        <table class="table table-sm table-borderless">
                            <thead>
                            <tr>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Name')}>Name {this.state.showName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>Action Required</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                // ----- table rows: -----
                                this.displayedTimelineTable().map((customer) => {
                                    return (
                                        <>
                                        <tr key={ customer.Id }  onClick={() => this.setState({ expandedTimelineRow: this.state.expandedTimelineRow === customer.Id ? '' : customer.Id })}>
                                            <td>
                                                <Link onClick={(e) => e.stopPropagation()} to={`/customers/${customer.Opportunity__c}`}>{ customer.Opportunity__r.Name }</Link>
                                            </td>
                                            <td>{ customer.actionRequired.map((action, i) => 
                                                <span key={action.name}>
                                                    {i > 0 ? ', ' : ''}
                                                    <span className={action.isRepAction ? 'text-danger' : ''}>{action.name}</span>
                                                </span>)}
                                            </td>
                                            <td><FontAwesomeIcon icon={this.state.expandedTimelineRow === customer.Id ? faCaretUp : faCaretDown}/></td>
                                        </tr>
                                        {this.state.expandedTimelineRow === customer.Id && (
                                            <>
                                            <tr className="d-none"></tr>
                                            <tr className="detail-row">
                                                <td colSpan={3} className="border border-2" style={{ textAlign: 'left' }}>
                                                    <div>
                                                        <div>
                                                            <b>Assigned Account Manager:</b>
                                                            <div>
                                                                {customer.Assigned_Account_Manager__r?.Name || '---'}
                                                            </div>
                                                            <br />
                                                        </div>
                                                        <div>
                                                            <b>Reviewed Date:</b>
                                                            <div>
                                                                {customer.Reviewed_Date__c ? moment(customer.Reviewed_Date__c, 'YYYY-MM-DD').format('MM/DD/YYYY') : '---'}
                                                            </div>
                                                            <br />
                                                        </div>
                                                        <div className={customer.Rep_Action_Requested__c ? '' : 'd-none'}>
                                                            <b>Rep Action Status:</b>
                                                            <div>
                                                                {customer.Rep_Action_Resolved__c ? 'Pending Review' : 'Action Needed'}
                                                            </div>
                                                            <br />
                                                        </div>
                                                        <div>
                                                            <b>Notes:</b>
                                                            <div>
                                                                {customer.Next_Step__c ? customer.Next_Step__c : '---'}
                                                            </div>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </>
                                        )}
                                        </>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    :

                    <div>
                        {/* ---------- Customers Table: ---------- */}
                        <table>
                            <thead>
                            <tr>
                                <th className={css.Customers__Pointer} onClick={() => this.tableSort('Name')}>Name {this.state.showName ? <FontAwesomeIcon icon={faCaretDown}/> : ''}</th>
                                <th>Action Required</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                // ----- table rows: -----
                                this.displayedTimelineTable()
                                    .map((customer) => {
                                        return (
                                            <>
                                            <tr key={ customer.Id } onClick={() => this.setState({ expandedTimelineRow: this.state.expandedTimelineRow === customer.Id ? '' : customer.Id })}>
                                                <td>
                                                    <Link onClick={(e) => e.stopPropagation()} to={`/customers/${customer.Opportunity__c}`}>{ customer.Opportunity__r.Name }</Link>
                                                </td>
                                                <td>{customer.actionRequired.map((action, i) => 
                                                    <span key={action.name}>
                                                        {i > 0 ? ', ' : ''}
                                                        <span className={action.isRepAction ? 'text-danger' : ''}>{action.name}</span>
                                                    </span>)}
                                                </td>
                                                <td><FontAwesomeIcon icon={this.state.expandedTimelineRow === customer.Id ? faCaretUp : faCaretDown}/></td>
                                            </tr>
                                            {this.state.expandedTimelineRow === customer.Id && (
                                                <>
                                                <tr className="d-none"></tr>
                                                <tr className="detail-row">
                                                    <td colSpan={3} className="border border-2" style={{ textAlign: 'left' }}>
                                                        <div>
                                                            <div>
                                                                <b>Assigned Account Manager:</b>
                                                                <div>
                                                                    {customer.Assigned_Account_Manager__r?.Name || '---'}
                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div>
                                                                <b>Reviewed Date:</b>
                                                                <div>
                                                                {customer.Reviewed_Date__c ? moment(customer.Reviewed_Date__c, 'YYYY-MM-DD').format('MM/DD/YYYY') : '---'}
                                                                </div>
                                                                <br />
                                                            </div>
                                                            <div className={customer.Rep_Action_Requested__c ? '' : 'd-none'}>
                                                                <b>Rep Action Status:</b>
                                                                <div>
                                                                    {customer.Rep_Action_Resolved__c ? 'Pending Review' : 'Action Needed'}
                                                                </div>
                                                                <br />
                                                            </div>
                                                            <div>
                                                                <b>Notes:</b>
                                                                <div>
                                                                    {customer.Next_Step__c ? customer.Next_Step__c : '---'}
                                                                </div>
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </>
                                            )}
                                            </>
                                        );
                                    })
                            }
                            </tbody>
                        </table>
                    </div>
                )}
                
            </div>
        );
    }
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(Customers);
